import {skipToken} from '@reduxjs/toolkit/query';
import {Box, Image, Integer} from 'platform/foundation';

import {isEmpty, isNil} from 'ramda';

import {useGetMakeModelWithMakeQuery} from '@dms/api/sales';

import {Nullish, TestIdProps} from 'shared/web';

import {CATALOGUE_MAKE_KEY_PREFIX} from '../../../constants/CATALOGUE_MAKE_KEY_PREFIX';

/** Logos are kept per make, so the passenger car catalogue covers vans of the same make too. */
const LOGO_VEHICLE_TYPE = 'VEHICLETYPE_PASSENGER_CAR';

interface MakeLogoProps extends TestIdProps {
  /** Catalogue make key, e.g. MAKE_VOLKSWAGEN. */
  make: string | Nullish;
  size: Integer;
}

/** Renders nothing for a make without a logo in the catalogue. */
export function MakeLogo(props: MakeLogoProps) {
  const make = props.make ?? '';
  const {data} = useGetMakeModelWithMakeQuery(
    make.startsWith(CATALOGUE_MAKE_KEY_PREFIX)
      ? {vehicleType: LOGO_VEHICLE_TYPE, make, logoUrl: true}
      : skipToken
  );

  const logoUrl = data?.[0]?.logo_url_2x;

  if (isNil(logoUrl) || isEmpty(logoUrl)) {
    return null;
  }

  // The box never shrinks next to a long title, otherwise it would crop the wide logos.
  return (
    <Box flexShrink={0} width={props.size} height={props.size}>
      <Image
        src={logoUrl}
        alt=""
        width={props.size}
        height={props.size}
        fit="contain"
        data-testid={props['data-testid']}
      />
    </Box>
  );
}
